import ArrowForward from '@mui/icons-material/ArrowForward';
import { Box, Card, CardContent, CardHeader, Stack, styled, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import ProductItemDefaultImg from 'src/asset/images/trade-data/ProductItemDefault.png';
import { UnknownText } from 'src/utils/constants/config';
import { useQueryParams } from 'src/hooks/useQueryParam';
import { handleQueryParamFromObject } from 'src/utils/helpers/queryParam';

const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  background: 'linear-gradient(180deg, #7551FF 0%, #3311DB 100%)',
  height: 48,
  padding: `${theme.spacing(2)} ${theme.spacing(1)}`,
  textAlign: 'center',
}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
}));

interface IProps {
  selected?: ITradeDataProductItem;
}

const ProductItemDetail = ({ selected }: IProps) => {
  const query = useQueryParams();

  const navigate = useNavigate();

  const theme = useTheme();

  const navigateToDetail = () => {
    if (selected?.code) {
      const newParams = {
        ...query,
        hs_code: selected.code,
      };
      navigate({ pathname: AuthRouteKeys.TradeData, search: handleQueryParamFromObject(newParams) });
    }
  };

  return (
    <Card>
      <StyledCardHeader
        title={
          <Typography color="white" variant="subtitle1">
            Quick View Panel
          </Typography>
        }
      />
      <StyledCardContent>
        <Box>
          <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'} mb={1}>
            <Box component={'img'} width={100} height={100} src={ProductItemDefaultImg} />
          </Stack>
          <Typography color={theme.palette.primary.main} variant="subtitle1">
            {selected?.code || UnknownText}
          </Typography>
        </Box>

        <Stack spacing={1}>
          <Typography color={theme.palette.text.secondary} variant="caption">
            {selected?.description}
          </Typography>
        </Stack>

        <ButtonWithLoading size="large" variant="contained" isRounded onClick={navigateToDetail}>
          Profile Detail <ArrowForward sx={{ ml: 1 }} fontSize="small" />
        </ButtonWithLoading>
      </StyledCardContent>
    </Card>
  );
};

export default ProductItemDetail;
